import { object } from "prop-types";
import React from "react"

interface ITable {
  headers: {
    size: number;
    title: string
  }[]
  rows: {
    link: string;
    data: {
      onClick: () => void
      icon?: string
    }[]
  }[] | object
  className?: string;
  showRowIndex?: boolean
}

export default ({ headers, rows, className, showRowIndex }: ITable) => {
  return (
    Array.isArray(rows) && rows.length > 0 ? <div className={"table w-100 flexed justify-c fdir-col " + className}>
      <div className="head flexed flex-1 pb-8">
        {
          headers.map((header, index) => (
            <div key={index} className={`flex-${header.size} text-center px-24`}>
              <span className="iran-sans-lighter text-semi-disabled">{header.title}</span>
            </div>
          ))
        }
      </div>
      <div className="body flexed flex-1 fdir-col">
        {
          rows.map((row, rowIndex) => (
            <a key={rowIndex} href={row.link} className="table-item button mt-12" target="_blank">
              <div className="flex-1 flexed align-c py-6">
                {showRowIndex && <div className={`flex-${headers[0].size} text-center px-24 py-16`}>
                  <span className="iran-sans">{rowIndex + 1}</span>
                </div>}
                {
                  row.data.map((cell, cellIndex) => (
                    <div key={cellIndex} {...(typeof (cell) !== 'object' ? { title: cell } : {})}
                      className={`flex-${headers[cellIndex + (showRowIndex ? 1 : 0)].size} text-center one-line px-24 py-16`}>
                      {typeof (cell) === 'object' ? <div onClick={e => {
                        // e.preventDefault()
                        e.stopPropagation()
                        cell.onClick && cell.onClick()
                      }}><cell.icon /></div> : <span>{cell}</span>}
                    </div>
                  ))
                }
              </div>
            </a>
          ))
        }
      </div>
    </div> : <div></div>
  )
}
